package top.wcpe.allincore.ui.runtime.theme

/**
 * Tooltip 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme` 的 `tooltipXxx` accessor 委托至此——签名不变、消费者零改动。
 * 字段名去 `tooltip` 前缀。默认值与原 `ControlTheme.Builder` 一致（零回归）。
 */
data class TooltipTokens(
    val delayMs: Long = DEFAULT_DELAY_MS,
    val backgroundColor: Int = DEFAULT_BACKGROUND,
    val textColor: Int = DEFAULT_TEXT,
    val cornerRadius: Float = DEFAULT_CORNER_RADIUS,
    val paddingX: Float = DEFAULT_PADDING_X,
    val paddingY: Float = DEFAULT_PADDING_Y,
    val lineSpacing: Float = DEFAULT_LINE_SPACING,
) {
    private companion object {
        private const val DEFAULT_DELAY_MS = 500L
        private const val DEFAULT_BACKGROUND = 0xE6000000.toInt()
        private const val DEFAULT_TEXT = 0xFFFFFFFF.toInt()
        private const val DEFAULT_CORNER_RADIUS = 2f
        private const val DEFAULT_PADDING_X = 4f
        private const val DEFAULT_PADDING_Y = 2f
        private const val DEFAULT_LINE_SPACING = 1.2f
    }
}
